
















import { VideoInfo } from '@/models/VideoInfo'
import { format } from 'date-fns'
import { formatRecordingTime } from '@/util'
import Vue, { PropType } from 'vue'

export default Vue.extend({
  name: 'VideoInfoViewer',
  props: {
    videoInfo: {
      type: Object as PropType<VideoInfo>,
      default: (): VideoInfo => ({
        userId: -1,
        title: '',
        name: '',
        language: undefined,
        comment: '',
        uploadTime: -1,
        recordingTime: -1,
      }),
      required: false,
    },
  },
  computed: {
    language: function (): string {
      return this.videoInfo.language?.name ?? ''
    },
    uploadTime: function (): string {
      if (this.videoInfo.uploadTime < 0) {
        return ''
      }
      return format(this.videoInfo.uploadTime, 'yyyy/MM/dd hh:mm:ss')
    },
    recordingTime: function (): string {
      if (this.videoInfo.recordingTime < 0) {
        return ''
      }
      return formatRecordingTime(this.videoInfo.recordingTime)
    },
  },
})
